import {Component, Input, OnInit} from '@angular/core';
import {PrimeTemplate} from "primeng/api";
import {ActivatedRoute, Router} from "@angular/router";
import {TramiteService} from "../../../../users/tramites/services/tramite.service";
import {LoginServices} from "../../../../auth/login/services/login.service";
import {BadgeModule} from "primeng/badge";
import {Button, ButtonDirective} from "primeng/button";
import {InputNumberModule} from "primeng/inputnumber";
import {InputTextModule} from "primeng/inputtext";
import {MenuModule} from "primeng/menu";
import {Location, NgIf} from "@angular/common";
import {Table, TableModule} from "primeng/table";
import {TagModule} from "primeng/tag";
import {TooltipModule} from "primeng/tooltip";
import {EvaluacionEstadosControl, SolicitudEvalDocTipoInterface} from "../../interfaces/evaluaciones.interface";
import {EvaluacionesService} from "../../services/evaluaciones.service";
import {ToolbarModule} from "primeng/toolbar";
import {NotificarSolicitudObsComponent} from "../notificar-solicitud-obs/notificar-solicitud-obs.component";
import {ProyectoItem} from "../../../../users/interfaces/proyecto.interface";

@Component({
  selector: 'app-dictamenes-evaluacion',
  standalone: true,
    imports: [
        BadgeModule,
        Button,
        InputNumberModule,
        InputTextModule,
        MenuModule,
        NgIf,
        PrimeTemplate,
        TableModule,
        TagModule,
        TooltipModule,
        ToolbarModule,
        NotificarSolicitudObsComponent
    ],
  templateUrl: './dictamenes-evaluacion.component.html',
  styleUrl: './dictamenes-evaluacion.component.scss'
})
export class DictamenesEvaluacionComponent implements OnInit{
    @Input("selected") selected: ProyectoItem | null = null;
    openDialog: boolean = false;
    cols: any [] = [];
    solicitudDictamenes: SolicitudEvalDocTipoInterface [] =[];
    seletedDictamen!: SolicitudEvalDocTipoInterface;
    protected readonly EvaluacionEstadosControl = EvaluacionEstadosControl;
    constructor(public router: Router, private location: Location, private route: ActivatedRoute,
                protected tramiteService: TramiteService, private loginServices: LoginServices, protected evaluacioneService: EvaluacionesService) {
    }
    ngOnInit(): void {
        this.getEvaluacioDocTipos(this.selected?.idSolicitud!)
    }

    getEvaluacioDocTipos(idSolicitud:number){
        let tipos: string[] = [EvaluacionEstadosControl.Dictamen.toString()];
        this.evaluacioneService.obtenerEvaluacioDocTipos(tipos,idSolicitud)
            .subscribe({
                next: (result) => {
                    if (result.status == 200) {
                        this.solicitudDictamenes=result.body!;
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
    }
    getEvaluacionesUsuarioQ1(idSolicitud:number, uniqueIdUsuario:string, idSolicitudEval:number,type:boolean){
        this.evaluacioneService.obtenerEvaluacioUsuarioDet(idSolicitud,uniqueIdUsuario,idSolicitudEval,type)
            .subscribe({
                next: (result) => {
                    if (result.status == 200) {
                        this.evaluacioneService._evaluaciones.set(result.body!);
                        this.openDialog=true; //se inicia como true cuando ya se obtiene la informacion
                    }
                },
                error: (error) => {
                    console.log(error)
                }
            });
    }
    openDialogReadonly(dictamen:SolicitudEvalDocTipoInterface) {
            if(dictamen){
                this.seletedDictamen=dictamen
                this.getEvaluacionesUsuarioQ1(dictamen.idSolicitud,dictamen.uniqueIdUsuario,dictamen.idEvaluacion!,true);
            }
    }
    onDialogClosed(event: boolean) {
        this.openDialog = event;
    }
    dictamenesFilter(table: Table, event: Event) {
        table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
    }
    goBack(): void {
        this.location.back();
    }
    tagStyle(estado: boolean) {
        switch (estado) {
            case true:
                return {background: '#28a745'};
            case false:
                return {background: '#FF0000FF'};
            default:
                return {background: '#6c757d'};
        }
    }
}
